import React, { Component } from "react";


export default class Flags extends Component {
  render() {
    const { deal, prefix } = this.props
    if (deal.flags.length === 0) return (null)
    return (
      <div className='flags-container'>

        {deal.flags.includes('sale_made') && <span className='toggle-flag toggle-flag-success'>{prefix && <span>{prefix}</span>}Sale Made</span>}
        {deal.flags.includes('awaiting_sale_verification') && <span className='toggle-flag toggle-flag-info'>{prefix && <span>{prefix}</span>}Awaiting Sale Verification</span>}
        {deal.flags.includes('sale_verified') && <span className='toggle-flag toggle-flag-success'>{prefix && <span>{prefix}</span>}Sale Verified</span>}

        {deal.flags.includes('awaiting_upgrade_call') && <span className='toggle-flag toggle-flag-info'>{prefix && <span>{prefix}</span>}Awaiting Upgrade Call</span>}

        {deal.flags.includes('upgrade_made') && <span className='toggle-flag toggle-flag-success'>{prefix && <span>{prefix}</span>}Upgrade Made</span>}
        {deal.flags.includes('awaiting_upgrade_verification') && <span className='toggle-flag toggle-flag-info'>{prefix && <span>{prefix}</span>}Awaiting Upgrade Verification</span>}
        {deal.flags.includes('upgrade_verified') && <span className='toggle-flag toggle-flag-success'>{prefix && <span>{prefix}</span>}Upgrade Verified</span>}

        {deal.flags.includes('awaiting_final_review') && <span className='toggle-flag toggle-flag-info'>{prefix && <span>{prefix}</span>}Awaiting Final Review</span>}

        {deal.flags.includes('deal_approved') && <span className='toggle-flag toggle-flag-success'>{prefix && <span>{prefix}</span>}Approved</span>}
        {deal.flags.includes('deal_declined') && <span className='toggle-flag toggle-flag-warning'>{prefix && <span>{prefix}</span>}Declined</span>}

        {deal.flags.includes('no_sale') && <span className='toggle-flag toggle-flag-warning'>{prefix && <span>{prefix}</span>}No Sale</span>}

        {deal.flags.includes('completed') && <span className='toggle-flag toggle-flag-success'>{prefix && <span>{prefix}</span>}Complete</span>}
        {deal.flags.includes('dead_deal') && <span className='toggle-flag toggle-flag-warning'>{prefix && <span>{prefix}</span>}Dead Deal</span>}
        {deal.flags.includes('tcs_cancelled') && <span className='toggle-flag toggle-flag-error'>{prefix && <span>{prefix}</span>}Cancelled</span>}
      </div>

    )
  }
}
